module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-100-normal.woff?c0293901ec8962e065eea32e1e99ebf5";